//@flow
import React from 'react';
import { Container } from 'flux/utils';
import OfficeShell from '../../Shell/components/OfficeShell.react';
import OfficeCatalog from './OfficeCatalog.react';
import ProductsStore from '../../Stores/Products/products';
import CategoriesStore from '../../Stores/MemberCategories/categories';
import StockStore from '../../Stores/Stock/stock';

import type { ContextRouter } from 'react-router';
import type CategoryModel from '../../Stores/MemberCategories/categoryModel';
import type ProductsCollection from '../../Stores/Products/productsCollection';
import type StockCollection from '../../Stores/Stock/stockCollection';

type State = {
  categories:CategoryModel[],
  products:ProductsCollection,
  stock:StockCollection,
  filterByStock:boolean,
};

type Props = ContextRouter;

class OfficeCatalogApp extends React.Component<Props, State> {
  static getStores() {
    return [
      ProductsStore,
      CategoriesStore,
      StockStore,
    ];
  }

  static calculateState(prevState:State, props:Props):State {
    return {
      products: ProductsStore.getProducts(),
      categories: CategoriesStore.getCorporateCategories().models,
      stock: StockStore.getStock(),
      filterByStock: props && props.route.name.indexOf('stock') > -1,
    };
  }

  render() {
    return (
      <OfficeShell helloBar={false}>
        <OfficeCatalog {...this.state} useSingleGrouping={true} />
      </OfficeShell>
    );
  }
}

export default Container.create(OfficeCatalogApp, { withProps: true });
